import React from 'react';
import { connect } from 'react-redux';
import { FormSection, formValueSelector } from 'redux-form';
import styled from 'styled-components';

import { Radio } from 'components/Shared/Forms';
import Collapse from 'components/Shared/Collapse';
import { controlsType } from 'modules/advancedSettings';
import CustomControlsSection from 'components/AdvancedSettings/CustomControlsSection';
import { SettingsHelper } from 'components/Shared/SettingsGroup';
import { SETTINGS_INPUTS } from 'theme';

const StyledFormSection = styled(FormSection)`
    margin-bottom: -${SETTINGS_INPUTS.PADDING.Y};
`;

const StyledCollapse = styled(Collapse)`
    margin-left: -${SETTINGS_INPUTS.PADDING.X};
    margin-right: -${SETTINGS_INPUTS.PADDING.X};
    padding-left: ${SETTINGS_INPUTS.PADDING.X};
    padding-right: ${SETTINGS_INPUTS.PADDING.X};
`;

const ControlsSection = ({ showCustom }) => {
    return (
        <StyledFormSection name="controls">
            <SettingsHelper>
                For more information on the controls available and their settings, please refer to the{' '}
                <a
                    href="https://developers.google.com/maps/documentation/javascript/controls"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Google Maps APIs documentation
                </a>
                .
            </SettingsHelper>
            <Radio name="type" label="Default Google Maps settings" value={controlsType.DEFAULT} />
            <Radio name="type" label="Hide all controls" value={controlsType.HIDE_ALL} />
            <Radio name="type" label="Custom" value={controlsType.CUSTOM} />
            <StyledCollapse isOpened={showCustom}>
                <CustomControlsSection />
            </StyledCollapse>
        </StyledFormSection>
    );
};

const selector = formValueSelector('advanced-form');

const mapStateToProps = (state) => ({
    showCustom: selector(state, 'controls.type') === controlsType.CUSTOM,
});

export default connect(mapStateToProps)(ControlsSection);
